import { createFileRoute, Link } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { PageContent } from "@/components/common/page-content"
import { Button } from "@/components/ui/button"
import { IndividualEmployments } from "@/features/individuals/components/individual-employments"
import { countryQueries } from "@/queries/countries"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/employment/"
)({
  staticData: { attention: "individual.employment" },
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(
        individualQueries.employments(params.individualId)
      ),
      context.queryClient.ensureQueryData(countryQueries.list()),
    ])
  },
  component: IndividualEmploymentPage,
})

function IndividualEmploymentPage() {
  const { individualId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="Employment history"
        actions={
          <Button
            nativeButton={false}
            render={
              <Link
                from="/$organisation"
                to="/$organisation/individuals/$individualId/employment/edit"
                params={{ individualId }}
              >
                Update history
              </Link>
            }
          />
        }
      />

      <PageContent>
        <IndividualEmployments individualId={individualId} />
      </PageContent>
    </>
  )
}
